import axios from "axios";
import { createHashHistory } from 'history';
import { message } from "antd";
import { getDataType } from "../utils";
class HttpRequest {
  interceptors (instance,contentType) {
    instance.interceptors.request.use(function (config) {
      // 在发送请求之前做些什么
      // const _token = store.getState().global.get("token") || cookies.load("token");
      //_token && (config.headers["token"] = _token);
      return config;
    }, function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    });

    // 添加响应拦截器
    instance.interceptors.response.use(function (response) {
      let { code, info } = response.data;
      if (code && code !== 200) {
        message.error({
          content: info
        });
        const errCode = [40002, 40001, 202];
        if (errCode.indexOf(code) > -1) {
          /**40002登录超时，重新登录*/
          setTimeout(function () {
            const history = createHashHistory();
            history.push('/');
          }, 300);
        }
      } else if (code && code === 200) {
        return Promise.resolve(response.data);
      } else {
        return Promise.resolve(response.data);
      }
      return Promise.resolve(response);
    }, function (error) {
      /**服务器状态码不是200的情况*/
      message.error({
        content: `请求错误-${error}`
      });
      // setTimeout(function () {
      //   const history = createHashHistory();
      //   history.push('/');
      // }, 300);
      return Promise.reject(error.response);
    });
  };

  request(option) {
    const { url, method = 'get', data, contentType = ""} = option;
    let instance = axios.create();
    let config = {
      url,
      method: method.toLowerCase(),
      contentType
    };
    if (config.method === "put" || config.method === "post" || config.method === "patch") {
      data && (config["data"] = data);
    } else {
      data && (config["params"] = filterData(data));
    }
    instance.defaults.timeout = 60000;
    //instance.defaults.headers.common["Content-Type"] = "application/x-www-form-urlencoded";
    this.interceptors(instance, config.contentType);
    return instance(config)
  }
}

const filterData = (data) => {
  let rData = {};
  for (let prop in data) {
    if (data.hasOwnProperty(prop)) {
      if (((getDataType(data[prop]) === "string" || getDataType(data[prop]) === "number") && data[prop] !== "") || ((getDataType(data[prop]) === 'array') && data[prop].length)) {
        rData[prop] = data[prop];
      }
    }
  }
  return rData
};

export default HttpRequest;
